import InfiniteScroll from "react-infinite-scroll-component";
import { UiComponents } from "@simulanisindia/ui";
import ResourceCard from "../../../components/ResourceCard";
import { RESOURCE_APPLICATION_TAB } from "../../../constant/constants";
import NoDataFound from "../../../components/NoDataFound";
import ResourceSkeleton from "../../../components/Skeleton/Resource";
import { defaultLogo } from "../../../Icons";

const { ApplicationCard, GridView, SimCheckBox } = UiComponents;

const ResourceTabComponent = ({
  handleCheckboxChange,
  id_link,
  type,
  selectedResource,
  hasMore,
  loadMoreData,
  activeTab,
  list=[],
}) => {
  const isApplicationTab = activeTab === RESOURCE_APPLICATION_TAB;

  const renderCheckbox = (item) => (
    <SimCheckBox
      checked={!!selectedResource[type]?.find((value) => value.id === item.id)}
      onChange={(e) =>
        handleCheckboxChange(e, id_link, type, {
          id: item.id,
          name: item.title,
          avatar: item.icon,
        })
      }
      id={item.id}
    />
  );

  const renderCard = (item, index) => {
    return isApplicationTab ? (
      <ApplicationCard
        key={index}
        beta={false}
        showResources={false}
        showRedirectIcon={false}
        name={item.title}
        description={item?.description || ""}
        logo={item.icon || defaultLogo}
        showCheckbox={true}
        checkbox={renderCheckbox(item)}
        
      />
    ) : (
      <ResourceCard
        key={index}
        name={item.title}
        image={item.icon}
        inActive={true}
        showCheckbox={true}
        checkbox={renderCheckbox(item)}
      />
    );
  };

  const renderContent = () => {
    if (!list.length)
      return (
        <div className="no-data2">
          <NoDataFound headText="No Data Found " />
        </div>
      );

    return (
      <div id="scrollableDivModuleResource" className="scrollable-container">
        <InfiniteScroll
          scrollThreshold={0.7}
          dataLength={list.length}
          next={loadMoreData}
          hasMore={hasMore}
          loader={<ResourceSkeleton length={5} />}
          scrollableTarget="scrollableDivModuleResource"
        >
          {" "}
          <GridView >{list.map(renderCard)}</GridView>
        </InfiniteScroll>
      </div>
    );
  };

  return <div className="reousce-app-mob-list">{renderContent()}</div>;
};

export default ResourceTabComponent;
